// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"103":"059183e8","437":"7e712a0a","483":"2f3929f1","593":"90d91f21","740":"3d1fd003","850":"b639a142"}[chunkId] + ".chunk.js";
};